import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Company {
  id: string
  icon?: string
  name: string
}

interface CompanyRoles {
  company_id: number
  company_name: string
  role_id: number
  role_name: string
}

export interface Profile {
  email: string
  name: string
  role: {
    id: number
    name: string
  }
  surname: string
  company?: Company
  company_roles: CompanyRoles[]
}

// Define the initial state type
interface UserState {
  profile: Profile | null
  currentCompany: Company | null
  settings: Record<string, boolean | number | string>
}

const initialState: UserState = {
  profile: null,
  currentCompany: null,
  settings: {},
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateProfile: (state, action: PayloadAction<Partial<Profile>>) => {
      state.profile = {
        ...state.profile,
        ...action.payload,
      }
    },
    updateCompany: (state, action: PayloadAction<Partial<Company>>) => {
      state.currentCompany = {
        ...state.currentCompany,
        ...action.payload,
      }
    },
    resetProfileOnSignOut: (state) => {
      state.profile = null
      state.currentCompany = null
      state.settings = {}
    },
    setSettings: (
      state,
      action: PayloadAction<Record<string, boolean | number | string>>
    ) => {
      state.settings = action.payload
    },
    mergeSettings: (state, action: PayloadAction<Record<string, boolean>>) => {
      state.settings = {
        ...state.settings,
        ...action.payload,
      }
    },
  },
})

export const {
  updateProfile,
  updateCompany,
  resetProfileOnSignOut,
  setSettings,
  mergeSettings,
} = userSlice.actions

export default userSlice.reducer
